<template>
  <section v-if="cardList.length > 0" class="main-card">
    <div class="main-title">
      <html-view :value="$t('main.card.title')" tag="h3" />
      <html-view :value="$t('main.card.subtitle')" tag="small" />
    </div>
    <div ref="cardSwiper" class="main-content">
      <div v-if="cardList.length > 0" class="main-card-list">
        <div
          v-for="(item, key) in cardList"
          v-if="item[locale]"
          :key="key"
          class="main-card-item"
          :style="`--card-image: url('${require(`@/static/image/main/card/image-${key + 1}.png`)}')`"
        >
          <a
            :href="item[locale].url"
            :target="setTarget(item[locale].url)"
            @click="setGtag({
              action: `click`,
              name: '메인_컨텐츠카드',
              category: '메인_컨텐츠카드',
              label: item.title.replace(/<[^>]*>/g, ''),
              page: '메인'
            })"
          >
            <html-view class="main-card-title" tag="strong" :value="item[locale].title" />
            <html-view class="main-card-category" tag="span" :value="item[locale].category" />
          </a>
        </div>
        <div v-if="cardList.length <= 0" class="empty">
          empty
        </div>
      </div>
      <div ref="cardPagination" class="swiper-pagination" />
    </div>
  </section>
</template>

<script>
import mainApi from '@/api/main'
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'
import gtag from '@/mixins/gtag'
import { mapGetters } from 'vuex'

Swiper.use([Navigation, Pagination, Autoplay])

export default {
  mixins: [gtag],
  data () {
    return {
      cardSlider: null,
      cardList: [
        {
          ko: {
            title: '숫자로 보는<br>배민아카데미 이야기',
            category: '배민아카데미',
            url: 'https://www.woowahan.com/sustainability/together/detail/273'
          },
          en: {
            title: 'The Story of Baemin Academy in Numbers',
            category: 'Baemin Academy',
            url: 'https://www.woowahan.com/en/sustainability/together/detail/276'
          },
        },
        {
          ko: {
            title: '사장님의 브랜드를<br>더 단단하게',
            category: '배민아카데미',
            url: 'https://www.woowahan.com/sustainability/together/detail/250'
          },
          en: {
            title: 'Helping restaurant owners make their brands more p',
            category: 'Baemin Academy',
            url: 'https://www.woowahan.com/en/sustainability/together/detail/251'
          },
        },
        {
          ko: {
            title: '배민에는 E만<br>다니나요?<br>오해 혹은 진실',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/5563/'
          },
        },
        {
          ko: {
            title: '본격 오피스 투어<br>어디서 일해요?',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/5043'
          },
        },
        {
          ko: {
            title: '우리가 함께 줄인<br> 일회용품이 이만큼!',
            category: '배민그린',
            url: 'https://www.woowahan.com/sustainability/together/detail/274'
          },
          en: {
            title: 'Check Out How Many Disposables',
            category: 'Baemin Green',
            url: 'https://www.woowahan.com/en/sustainability/together/detail/278'
          }
        },
        {
          ko: {
            title: '사장님의<br> 장사 경험을 위한<br> 특별한 공간',
            category: '배민아카데미 ',
            url: 'https://www.woowahan.com/sustainability/together/detail/248'
          }
        },
        {
          ko: {
            title: '배달을 위한<br> 인공지능이 있다고?',
            category: '기술과 서비스',
            url: 'https://story.baemin.com/6052/'
          },
          en: {
            title: 'AI<br> for Delivery',
            category: '기술과 서비스',
            url: 'https://story.baemin.com/6052/'
          },
        },
        {
          ko: {
            title: '그림일까?<br>글자일까?',
            category: '글꼴',
            url: 'https://www.woowahan.com/fonts'
          },
        },
        {
          ko: {
            title: '일회용품 없이<br> 배달을 즐기는 방법',
            category: '배민그린',
            url: 'https://www.woowahan.com/sustainability/together/detail/275'
          },
          en: {
            title: 'Enjoying Delivery Without Single-Use Plastics',
            category: 'Baemin Green',
            url: 'https://www.woowahan.com/en/sustainability/together/detail/277'
          }
        },
        {
          ko: {
            title: '여러분은<br> 뭐하고 쉬세요?',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/5100/'
          },
        },
        {
          ko: {
            title: '사장님의 든든한<br>버팀목이<br>되어드릴게요!',
            category: '이웃과 함께',
            url: 'https://www.woowahan.com/sustainability/together/detail/257'
          },
          en: {
            title: 'We will be there for our restaurant owners in need',
            category: 'Baemin Neighbors',
            url: 'https://www.woowahan.com/en/sustainability/together/detail/258'
          }
        },
        {
          ko: {
            title: '전사교육팀은<br>구성원의 성장을<br> 고민해요',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/3472/'
          },
        },
        {
          ko: {
            title: '배민상회에서는<br>뭘 팔아요?',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/3795/'
          },
        },
        {
          ko: {
            title: '일 잘하는 사람들의<br>비장의 장비',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/5672/'
          },
        },
        {
          ko: {
            title: '신규입사자의 일기',
            category: '일하기 좋은 회사',
            url: 'https://story.baemin.com/5632/'
          },
        },
      ],
    }
  },
  watch: {
    '$route.params.locale' () {
      if (this.cardSlider) {
        this.cardSlider.destroy()
      }
      this.getList()
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE'
    })
  },
  beforeDestroy () {
    if (this.cardSlider) {
      this.cardSlider.destroy()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      // const { data } = await mainApi.getCardList()
      //
      // this.cardList = data.filter((item, i) => {
      //   return i < 16
      // })

      if (this.cardList.length > 0) {
        this.$nextTick(this.setCardSwiper)
      }
    },
    setCardSwiper () {
      const that = this
      const options = {
        autoplay: {
          delay: 1,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        loop: true,
        spaceBetween: 0,
        // centerInsufficientSlides: true,
        slidesPerGroup: 1,
        slidesPerView: 'auto',
        freeMode: {
          enabled: true,
          momentum: false
        },
        grabCursor: true,
        speed: 3000,
        mousewheel: {
          releaseOnEdges: true,
        },
        slideClass: 'main-card-item',
        wrapperClass: 'main-card-list',
        // breakpoints: {
        //   // when window width is >= 280px
        //   280: {
        //     slidesPerGroup: 3,
        //   },
        //   // when window width is >= 980px
        //   980: {
        //     slidesPerGroup: 8,
        //   }
        // },
        // pagination: {
        //   el: this.$refs.cardPagination,
        //   type: 'bullets',
        //   clickable: true,
        //   renderBullet: function (index, className) {
        //     return `<button type="button" class="${className}">${index + 1}</button>`
        //   },
        //   bulletActiveClass: 'active',
        //   bulletClass: 'swiper-pagination-bullet',
        //   bulletElement: 'button',
        //   modifierClass: ''
        // },
        // navigation: false,
        on: {
          afterInit (s) {
            that.intersection()
          }
        }
      }

      this.cardSlider = new Swiper(this.$refs.cardSwiper, options)
    },
    setTarget (link) {
      if (/(?:[\w.]*?)(?:[beta]?)woowahan.com/.test(link)) {
        return '_self'
      } else {
        return '_blank'
      }
    },
    intersection () {
      const onSlideChange = (s) => {
        if (s.slides[s.snapIndex].dataset.isExposed === 'true') {
          return
        }

        const item = this.cardList[s.realIndex]

        this.setGtag({
          action: 'view',
          name: '메인_컨텐츠카드',
          category: '메인_컨텐츠카드',
          label: item.cardName,
          page: '메인'
        })

        s.slides[s.snapIndex].dataset.isExposed = 'true'
      }

      const parentEl = this.$refs.cardSwiper
      const io = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            this.cardSlider.on('slideChange', onSlideChange)
          } else {
            this.cardSlider.off('slideChange', onSlideChange)
          }
        })
      })

      io.observe(parentEl)
    },
  }
}
</script>
